import * as React from 'react';
import { UserTypes } from 'src/modules/Auth/store/types';
import { ILinkedRoute } from 'src/modules/Routing/types';
import { useNavLink } from 'src/modules/Navigation/NavBar/hooks/useNavLink';
import NavigationLink from 'src/modules/Navigation/NavBar/components/NavigationLink';
import '../sidebar.css';

interface ISidebarLinkProps {
  to: string;
  label: string;
  counter?: number;
  isActive?: boolean;
  onClick?: (event: any) => any;
  routes: ILinkedRoute[];
  userType: UserTypes;
  filterPath?: string;
}

const SidebarLink = (props: ISidebarLinkProps) => {
  const { counter, filterPath, to, isActive, onClick, label, routes, userType } = props;
  const [navLink] = useNavLink(to, routes, userType);
  return (
    navLink.authorized ?
      <NavigationLink
        counter={counter}
        filterPath={filterPath}
        handleClick={onClick}
        isActive={isActive}
        navTitle={label}
        routePath={to}
        isSidebar={true}
      /> : null
  );
}

export default SidebarLink;
